import { Intersection, IntersectionsV5Response } from '../api/ontology';

export type IntersectionEdges =
  IntersectionsV5Response['intersections'][number]['edges'];

export const getIntersectionEdges = (
  intersection: Intersection
): IntersectionEdges => intersection.source_edges ?? intersection.edges ?? [];

export interface DirectionCounts {
  positive: number;
  negative: number;
  neutral: number;
  total: number;
}

export const countDirections = (edges: IntersectionEdges): DirectionCounts =>
  edges.reduce<DirectionCounts>(
    (acc, edge) => {
      const direction = edge.attributes.exposure_direction;
      if (!direction) {
        return acc;
      }
      acc[direction] += 1;
      acc.total += 1;
      return acc;
    },
    { positive: 0, negative: 0, neutral: 0, total: 0 }
  );

export const toThemeDirections = (
  counts: DirectionCounts,
  t: (key: string) => string
) => {
  if (counts.total === 0) {
    return [];
  }
  return [
    {
      name: t('widget:themeOverview.tabs.overview.directionSplit.positive'),
      value: counts.positive / counts.total,
      color: '--viz-bullish',
    },
    {
      name: t('widget:themeOverview.tabs.overview.directionSplit.negative'),
      value: counts.negative / counts.total,
      color: '--viz-bearish',
    },
    {
      name: t('common:neutral'),
      value: counts.neutral / counts.total,
      color: '--surface-neutral',
    },
  ];
};
